
import { mapGetters } from 'vuex'
export default {
  inject: ['wordingPageProduct'],
  props: {
    productSelected: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    wording: null,
  }),
  computed: {
    ...mapGetters({
      vxSizeFit: 'common/getProductsFeaturesIcons',
    }),
    fittingGuideIndicator() {
      switch (this.productSelected?.fitting_guide) {
        case 'runs_small_size_up':
          return 'left'
        case 'between_small_true':
          return 'middle-left'
        case 'true_to_size':
          return 'center'
        case 'between_large_true':
          return 'middle-right'
        case 'runs_large_size_down':
          return 'right'
        default:
          return null
      }
    },
  },
  methods: {
    getAmount(amount) {
      if (this.$i18n.locale === 'en-us')
        return `${Math.round(amount / 2.54)} ${
          this.productSelectedPageProduct.size_fit_inche
        }`
      else if (this.$i18n.locale.includes('-ca'))
        return `${Math.round(amount)} ${
          this.wordingPageProduct.size_fit_centimeter
        } | ${Math.round(amount / 2.54)} ${
          this.wordingPageProduct.size_fit_inche
        }`
      else
        return `${Math.round(amount)} ${
          this.wordingPageProduct.size_fit_centimeter
        }`
    },
    getAmountMM(amount) {
      if (this.$i18n.locale === 'en-us')
        return `${Math.round(amount / 2.54 / 10)} ${
          this.wordingPageProduct.size_fit_inche
        }`
      else if (this.$i18n.locale.includes('-ca'))
        return `${Math.round(amount)} ${
          this.wordingPageProduct.size_fit_millimeter
        } | ${Math.round(amount / 2.54) / 10} ${
          this.wordingPageProduct.size_fit_inche
        }`
      else
        return `${Math.round(amount)} ${
          this.wordingPageProduct.size_fit_millimeter
        }`
    },
    haveDimensions() {
      return !!(
        this.productSelected.sizes_details.dimensions.default ||
        this.productSelected.sizes_details.dimensions.height ||
        this.productSelected.sizes_details.dimensions.width ||
        this.productSelected.sizes_details.dimensions.depth ||
        this.productSelected.sizes_details.dimensions.top_handle_drop_length ||
        this.productSelected.sizes_details.dimensions
          .adjustable_shoulder_strap_drop_length ||
        this.productSelected.sizes_details.dimensions.strap_length
      )
    },
  },
}
